import { Component } from 'react'
import Select from '../../components/Select'
import styles from '~/styles/ordersPage.carrierFilter.module.css'

export default class CarrierFilter extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders' ],
		}
	}

	public constructor(props) {
		super(props)
	}

	public render(): JSX.Element {
		if (this.props.show) {
			const options = []
			let value = null
			this.props.appState.carrierFilterOptions.forEach(key => {
				const data = { value: key, label: key }
				options.push(data)
				if (key === this.props.appState.carrierFilter) {
					value = data
				}
			})

			return (
				<div
					className={styles.main}
				>
					<Select
		                name='carrierFilter'
		                onSelect={this._onSelect.bind(this)}
		                options={options}
		                placeholder={this.props.t('All carriers')}
		                value={value}
		                clickLabel='sdsd'
		                show={true}
		            />
				</div>
			)
		} else {
			return null
		}
	}

	private _onSelect(data) {
		const value = data?.value || null
		this.props.setAppState({ carrierFilter: value })
		this._setLocalStorage(value)
	}

	private _setLocalStorage(value?: any): void {
	    try {
	    	window.localStorage.setItem('carrierFilter', JSON.stringify(value))
	    } catch(e) {}
	}
}